<template>
	<div class="finish-picker">
		<h3 class="heading">Select a colour or finish</h3>
		<div class="finish-groups">
			<div v-for="finishGroup in finishGroups" :key="finishGroup.handle">
				<FinishGroup :finish-group="finishGroup" :finishSelectedProp="finishSelectedProp" @finishSelected="onFinishSelected" />
			</div>
		</div>
		<div class="summary-panel">
			<h5 class="summary-heading">Selected colour or finish: {{ finishSelectedProp.title }}</h5>
			<div class="summary">
				<div class="thumbnail">
					<img :src="finishSelectedProp.thumbnail" :alt="finishSelectedProp.title" class="finish">
				</div>
				<div class="info">
					<p> For help & inspiration on choosing the right colour scheme for your home you can visit our <a href="/colours-finishes">Colours & Finishes</a> page.</p>
				</div>
			</div>
			<p class="footnote">Colours shown are not exact representations. For more information please see our <a href="/colours-finishes">colour range page</a>.</p>
			<GroupButton :urlProp="'/colour-range-and-samples'" :labelProp="'Request a colour chart'" :colourProp="'hotpink'" />
		</div>
	</div>
</template>

<script>
	import FinishGroup from './FinishGroup.vue';
	import GroupButton from './GroupButton.vue';

	export default {
			props: ['finishGroups', 'finishSelectedProp'],
			data() {
				return {
					finishSelected: null,
				};
			},
			components: {
				FinishGroup,
				GroupButton,
			},
			methods: {
				onFinishSelected: function(finish) {
					this.finishSelected = finish;
					this.$emit('finishSelected', this.finishSelected);
				}
			}
	};
</script>

<style scoped>
	.finish-picker {
		border-top: 1px solid #2B2012;
	}

	.heading {
		font-size: 16px;
		line-height: 1.2;
		margin: 10px 0;
	}

	.finish-groups,
	.summary-panel {
		padding: 2rem;
		background-color: #eee;
	}

	.summary-heading {
		font-size: 12px;
		margin: 12px 0;
		line-height: 1.2;
		text-transform: uppercase;
	}

	.summary {
		display: flex;
		justify-content: space-between;
	}

	.finish {
		border: 1px solid #eee;
	}

	.info {
		margin: 0 0 0 2rem;
	}

	.footnote {
		margin: 12px 0 24px;
		font-size: 1.2rem;
	}
</style>